export const removeBackendErrorCode = (error: string) => {
  if (!error?.match(/"((?:\\.|[^"\\])*)"/)) {
    return error;
  }
  /* eslint-disable no-unsafe-optional-chaining */
  const [_, errMsg] = error?.match(/"((?:\\.|[^"\\])*)"/);
  return errMsg;
};
